import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@material-ui/core';
import useStyles from './index.style';
import CmtSearch from '../../../@coremat/CmtSearch';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Add } from '@material-ui/icons';
import { useHistory } from 'react-router';
import { clearCurrentPayoff, setFinanceFilter } from 'redux/actions/Finance';
import { viewXSLX } from 'services/http/viewFiles';
import useDebounce from '@jumbo/utils/hooks/useDebounce/useDebounce';

const AppHeader = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { financeFilter } = useSelector(({ finance }) => finance);
  const { by_user_name } = financeFilter;

  const [generalExportLoading, setGeneralExportLoading] = React.useState(false);
  const [bankExportLoading, setBankExportLoading] = React.useState(false);
  const [search, setSearch] = React.useState(by_user_name);

  const searchDebounced = useDebounce(search, 500);

  React.useEffect(() => {
    dispatch(setFinanceFilter({ by_user_name: searchDebounced, page: 1 }));
  }, [searchDebounced, dispatch]);

  return (
    <Box className={classes.inBuildAppHeader}>
      <Box className={classes.inBuildAppHeaderSidebar}>
        <Typography className={classes.inBuildAppHeaderTitle} component="div" variant="h3">
          لیست تسویه حساب
        </Typography>
        <div style={{ marginRight: 16 }}>
          <CmtSearch
            placeholder="جستجو..."
            value={search}
            onChange={event => setSearch(event.target.value)}
            border={false}
          />
        </div>
      </Box>

      <Box className={classes.inBuildAppHeaderContent}>
        <Box ml="auto" display="flex" alignItems="center">
          <Box ml={1}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                dispatch(clearCurrentPayoff());
                history.push(`/manage-payeoff`);
              }}
              endIcon={<Add />}>
              افزودن
            </Button>
          </Box>
        </Box>
        <Box ml="auto" display="flex" alignItems="left">
          <Box ml={8}>
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="secondary"
                disabled={generalExportLoading}
                onClick={event => {
                  event.preventDefault();
                  setGeneralExportLoading(true);
                  viewXSLX(`/share/v1/export_pay_offs.xlsx`, setGeneralExportLoading);
                }}
                endIcon={<ReceiptIcon />}>
                اکسل جامع
              </Button>
              {generalExportLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Box>
        </Box>
        <Box ml="auto" display="flex" alignItems="left">
          <Box ml={8}>
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="secondary"
                disabled={bankExportLoading}
                onClick={event => {
                  event.preventDefault();
                  setBankExportLoading(true);
                  viewXSLX(`/share/v1/export_bank_pay_offs`, setBankExportLoading);
                }}
                endIcon={<ReceiptIcon />}>
                اکسل خروجی بانک
              </Button>
              {bankExportLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AppHeader;

AppHeader.prototype = {
  onChangeViewMode: PropTypes.func,
};
